import React, { useState } from 'react'
import styles from './Hint.module.scss'

const Hint = ({question, children}) => {

    const [isActive, setIsActive] = useState(false);


    return (
        <li className={styles.hint}>
            <div className={styles.container}>
                <div className={styles.box} onClick={() => setIsActive(!isActive)}>
                    <div className={styles.hint_box}>
                        <h3 className={styles.title}>{question}</h3>
                    </div>
                    <div className={styles.hint_boxs}>
                        <div className={!isActive ? styles.hint_image_box : styles.hint_active}  onClick={() => setIsActive(!isActive)}>
                            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.24268L6.65685 6.89953L12.3137 1.24268" stroke="#1F2120"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className={`${isActive === true ? styles.content : styles.content_no}`}>
                    {children}
                </div>
            </div>
        </li>
    )
}

export default Hint